var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.89 184.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: .15px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #c9c9c9;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #cc0202;\n        stroke-width: .11px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.05,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.09,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.09,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.09,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.12,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.12,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.12,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.12,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.12,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.12,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.12,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 72.36,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.19,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.19,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.19,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.19,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.19,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.19,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.19,
    y: 72.36,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.19,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.19,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.22,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.22,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.22,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.22,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.22,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.26,
    y: 152.7,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.26,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.26,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.26,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.26,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.26,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.26,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.26,
    y: 32.19,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.26,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.29,
    y: 160.73,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.29,
    y: 152.7,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.29,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.29,
    y: 136.63,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.29,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.29,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.29,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.29,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.29,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.29,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.29,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.29,
    y: 40.22,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.29,
    y: 32.19,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.29,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.29,
    y: 16.12,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.33,
    y: 160.73,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.33,
    y: 152.7,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.33,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 72.36,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.33,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.33,
    y: 16.12,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.36,
    y: 152.7,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.36,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.36,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.36,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.36,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.36,
    y: 72.36,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.36,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.36,
    y: 32.19,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.36,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 168.77,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 160.73,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 152.7,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 136.63,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.39,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.39,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.39,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.39,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 40.22,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 32.19,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 16.12,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.39,
    y: 8.09,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 176.8,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 168.77,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 160.73,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 152.7,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.43,
    y: 136.63,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.43,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.43,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 72.36,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.43,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.43,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.43,
    y: 40.22,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 32.19,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 16.12,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 8.09,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 0.05,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.8,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 168.77,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 168.77,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 168.77,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.73,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.73,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.73,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.73,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.73,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.73,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.73,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.7,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.7,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.7,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.7,
    y: 72.36,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.7,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.7,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.7,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.7,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.7,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.7,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.7,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 72.36,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.63,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.63,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 136.63,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.63,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.63,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 128.6,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 128.6,
    y: 32.19,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.6,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 128.6,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.6,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 128.6,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.6,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 128.6,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 128.6,
    y: 152.7,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.56,
    y: 16.12,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.56,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.56,
    y: 32.19,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.56,
    y: 40.22,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.56,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.56,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.56,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.56,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.56,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.56,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.56,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.56,
    y: 136.63,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.56,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.56,
    y: 152.7,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.56,
    y: 160.73,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.53,
    y: 16.12,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.53,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.53,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.53,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.53,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.53,
    y: 72.36,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.53,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.53,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.53,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.53,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.53,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.53,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.53,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.53,
    y: 152.7,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.53,
    y: 160.73,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.5,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.5,
    y: 32.19,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 72.36,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.5,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.5,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.5,
    y: 152.7,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 8.09,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 16.12,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 32.19,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 40.22,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.46,
    y: 56.29,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.46,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 80.39,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 96.46,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.46,
    y: 112.53,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.46,
    y: 120.56,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 136.63,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 152.7,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 160.73,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.46,
    y: 168.77,
    width: 8.03,
    height: 8.03
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset6);
export default __webpack_public_path__ + "static/media/Asset6.0aa652dad5a5117692f8ac0332f06393.svg";
export { ForwardRef as ReactComponent };